import { Link } from "react-router-dom";
import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import useDocumentMeta from "@/hooks/useDocumentMeta";

export default function NotFound() {
  useDocumentMeta({
    title: "Page Not Found | Integrated Wellness",
    description: "The page you're looking for doesn't exist. Explore Integrated Optimization Programs instead.",
  });

  return (
    <div data-testid="not-found-page" className="min-h-screen bg-background">
      <Header />
      <main className="pt-32 md:pt-40 pb-24 md:pb-32">
        <section className="relative max-w-2xl mx-auto px-4 md:px-8 text-center">
          <div className="absolute inset-0 iw-grid-bg opacity-30 -z-10" aria-hidden="true" />
          <div className="iw-overline">Error 404</div>
          <h1 className="mt-4 font-display font-bold tracking-tight leading-[1.05] text-[clamp(2.5rem,6vw,4.5rem)] text-primary">
            Page not <em className="not-italic text-accent">found</em>
          </h1>
          <p className="mt-5 text-lg text-foreground/75 leading-relaxed">
            This route doesn't exist in our system. Let's get you back to a page that does.
          </p>
          <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/"
              data-testid="not-found-home-link"
              className="inline-flex items-center justify-center bg-accent text-accent-foreground font-mono text-xs uppercase tracking-[0.18em] font-semibold px-8 py-4 hover:opacity-90 transition-opacity"
            >
              Back to Home →
            </Link>
            <Link
              to="/get-started"
              data-testid="not-found-assessment-link"
              className="inline-flex items-center justify-center border-2 border-primary text-primary font-mono text-xs uppercase tracking-[0.18em] font-semibold px-8 py-4 hover:bg-primary hover:text-primary-foreground transition-colors"
            >
              Start My Health Assessment
            </Link>
          </div>
          <p className="mt-8 font-mono text-[0.62rem] uppercase tracking-[0.2em] text-foreground/45">
            Or take the <Link to="/quiz" className="text-accent underline underline-offset-4">30-second program quiz</Link>
          </p>
        </section>
      </main>
      <Footer />
    </div>
  );
}
